import { styled } from '@mui/material/styles';

const StyledProcessingPage = styled('div')`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  & > div:first-of-type {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  & > div:first-of-type > ul {
    list-style: none;
    padding: 0;
  }
  & > div:first-of-type > ul > li:not(:first-of-type) {
    margin-top: 1rem;
  }

  .dots::after {
    content: '';
    display: inline-block;
    width: 50px;
    animation: ellipsisAnimation 1.5s infinite;
  }

  @keyframes ellipsisAnimation {
    0% {
      content: '';
    }
    33% {
      content: '.';
    }
    66% {
      content: '..';
    }
    100% {
      content: '...';
    }
  }
`;

export default StyledProcessingPage;
